import { z } from 'zod';

/** Stati operativi del DDT attivo (`pos_ddt_headers.status`). */
export const POS_ACTIVE_DDT_STATUSES = ['emesso', 'in_transito', 'consegnato', 'fatturato', 'annullato'] as const;
export const posActiveDdtStatusSchema = z.enum(POS_ACTIVE_DDT_STATUSES);
export type PosActiveDdtStatus = z.infer<typeof posActiveDdtStatusSchema>;

/** Stati del DDT passivo (`pos_ddt_passivi.status`). */
export const POS_PASSIVE_DDT_STATUSES = [
  'bozza', 'importato', 'confermato', 'caricato_parziale', 'caricato', 'ricevuto', 'fatturato', 'escluso', 'annullato',
] as const;
export const posPassiveDdtStatusSchema = z.enum(POS_PASSIVE_DDT_STATUSES);
export type PosPassiveDdtStatus = z.infer<typeof posPassiveDdtStatusSchema>;

const cancelReason = z.string().trim().min(1).max(500);

/** Body di `PUT /pos/ddt/:id/status`: il motivo è obbligatorio solo per l'annullo. */
export const posActiveDdtStatusBodySchema = z.object({
  status: posActiveDdtStatusSchema,
  reason: cancelReason.optional(),
  warehouse_id: z.string().uuid().nullish(),
}).strict().superRefine((value, context) => {
  if (value.status === 'annullato' && !value.reason) {
    context.addIssue({ code: z.ZodIssueCode.custom, path: ['reason'], message: 'Motivo dell\'annullo obbligatorio' });
  }
});
export type PosActiveDdtStatusBody = z.infer<typeof posActiveDdtStatusBodySchema>;

/** Body di `POST /pos/ddt-passivi/:id/transition`. */
export const posPassiveDdtTransitionBodySchema = z.object({
  status: posPassiveDdtStatusSchema,
  reason: cancelReason.optional(),
}).strict();
export type PosPassiveDdtTransitionBody = z.infer<typeof posPassiveDdtTransitionBodySchema>;

/**
 * Dettaglio del rifiuto fail-closed dell'annullo con storno (409
 * `ddt_cancel_units_blocked` / `ddt_cancel_stock_unavailable`): elenco
 * completo di ciò che impedisce il rientro, mai storni parziali.
 */
export const posDdtCancelBlockingUnitSchema = z.object({
  serial_number: z.string(),
  product_name: z.string().nullable(),
  status: z.string().nullable(),
  logistic_status: z.string().nullable(),
}).strict();
export type PosDdtCancelBlockingUnit = z.infer<typeof posDdtCancelBlockingUnitSchema>;

export const posDdtCancelBlockingLineSchema = z.object({
  product_name: z.string().nullable(),
  lot_number: z.string().nullable(),
  required: z.number(),
  available: z.number(),
}).strict();
export type PosDdtCancelBlockingLine = z.infer<typeof posDdtCancelBlockingLineSchema>;

export const posDdtCancelBlockedDetailsSchema = z.object({
  blocking_units: z.array(posDdtCancelBlockingUnitSchema),
  blocking_lines: z.array(posDdtCancelBlockingLineSchema),
}).strict();
export type PosDdtCancelBlockedDetails = z.infer<typeof posDdtCancelBlockedDetailsSchema>;
